import storage from "./storage";

const config = {
  imagesBaseURL: 'https://manager.present-team.eu/images/',
  imagesDevBaseURL: 'https://manager.presentteam.eu/images/',
  eshop_title: 'Present Team',
  enviroment: process.env.REACT_APP_ENVIRONMENT ?? 'local'
};

window.config = config;
export default config;